export const opsRoles = ["admin", "finance", "reviewer"];

export function hasOpsAccess(member) {
  return opsRoles.includes(member?.role);
}

export function defaultRouteForMember(member) {
  return hasOpsAccess(member) ? "/admin" : "/dashboard";
}
